import { Star } from 'lucide-react';
import type { ReviewStats as ReviewStatsType } from '../../types';

interface ReviewStatsProps {
    stats: ReviewStatsType;
}

export function ReviewStats({ stats }: ReviewStatsProps) {
    const { averageRating, totalCount, distribution } = stats;

    // Get max distribution count for bar width calculation
    const maxCount = Math.max(...Object.values(distribution), 1);

    return (
        <div className="bg-white border border-gray-100 rounded-xl p-5 space-y-4">
            {/* Average Rating */}
            <div className="flex items-center gap-4">
                <div className="text-center">
                    <div className="text-4xl font-bold text-gray-900">
                        {averageRating > 0 ? averageRating.toFixed(1) : '-'}
                    </div>
                    <div className="flex items-center justify-center gap-0.5 mt-1">
                        {[1, 2, 3, 4, 5].map((star) => (
                            <Star
                                key={star}
                                className={`w-4 h-4 ${star <= Math.round(averageRating)
                                        ? 'fill-yellow-400 text-yellow-400'
                                        : 'text-gray-200'
                                    }`}
                            />
                        ))}
                    </div>
                    <p className="text-xs text-gray-500 mt-1">{totalCount} avis</p>
                </div>

                {/* Distribution Bars */}
                <div className="flex-1 space-y-1.5">
                    {[5, 4, 3, 2, 1].map((rating) => {
                        const count = distribution[rating as 1 | 2 | 3 | 4 | 5];
                        const percentage = maxCount > 0 ? (count / maxCount) * 100 : 0;
                        return (
                            <div key={rating} className="flex items-center gap-2">
                                <span className="text-xs text-gray-500 w-3">{rating}</span>
                                <Star className="w-3 h-3 fill-yellow-400 text-yellow-400" />
                                <div className="flex-1 h-2 bg-gray-100 rounded-full overflow-hidden">
                                    <div
                                        className="h-full bg-yellow-400 rounded-full transition-all duration-500"
                                        style={{ width: `${percentage}%` }}
                                    />
                                </div>
                                <span className="text-xs text-gray-400 w-6 text-right">
                                    {count}
                                </span>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
}
